import { render, staticRenderFns } from "./NewFutureDeliveryRequest.vue?vue&type=template&id=e96dbe92"
import script from "./NewFutureDeliveryRequest.vue?vue&type=script&lang=js"
export * from "./NewFutureDeliveryRequest.vue?vue&type=script&lang=js"
import style0 from "./NewFutureDeliveryRequest.vue?vue&type=style&index=0&id=e96dbe92&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports